module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kOdhd"))).then(() => parcelRequire('d0iPb'));